import { request } from "../utils/request.js"

export const fundAccountTransferOrder_exportForManage = (pojo, args) => request({
    url: 'fundAccountTransferOrder/exportForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const fundAccountTransferOrder_findPageForManage = (pojo, args) => request({
    url: 'fundAccountTransferOrder/findPageForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const fundAccountTransferOrder_findPageListForManage = (pojo, args) => request({
    url: 'fundAccountTransferOrder/findPageListForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const fundAccountTransferOrder_findPageForCurrentUser = (pojo, args) => request({
    url: 'fundAccountTransferOrder/findPageForCurrentUser',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const fundAccountTransferOrder_findPageListForCurrentUser = (pojo, args) => request({
    url: 'fundAccountTransferOrder/findPageListForCurrentUser',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})


export const fundAccountTransferOrder_saveIntoDraft = (pojo, args) => request({
    url: 'fundAccountTransferOrder/saveIntoDraft',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const fundAccountTransferOrder_saveIntoDraftAndSubmit = (pojo, args) => request({
    url: 'fundAccountTransferOrder/saveIntoDraftAndSubmit',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const fundAccountTransferOrder_update = (pojo, args) => request({
    url: 'fundAccountTransferOrder/update',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const fundAccountTransferOrder_updateAndSubmit = (pojo, args) => request({
    url: 'fundAccountTransferOrder/updateAndSubmit',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const fundAccountTransferOrder_submitById = (id, args) => request({
    url: 'fundAccountTransferOrder/submitById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const fundAccountTransferOrder_deleteById = (id, args) => request({
    url: 'fundAccountTransferOrder/deleteById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const fundAccountTransferOrder_approval = (pojo, args) => request({
    url: 'fundAccountTransferOrder/approval',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const fundAccountTransferOrder_findById = (id, args) => request({
    url: 'fundAccountTransferOrder/findById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})


// WEBPACK FOOTER //
// ./src/api/fundAccountTransferOrder.js